<template>
  <div>
    <v-row no-gutters align="center">
      <v-col cols="6">
        <modal-cadu @input="$emit('close')" :close="close" :width="width" :value="show">
          <div slot="all" class="py-8 px-10">
            <div slot="body">
              <v-row no-gutters>
                <v-col cols="12" align="center">
                  <div>
                    <icon name="check" :size="70" :style="iconStyle" />
                  </div>
                </v-col>
                <v-col cols="12" align="center">
                  <div class="font-secundaria headline font-weight-bold">{{genericTitle}}</div>
                </v-col>
                <v-col cols="12" align="center" class="pt-2">
                  <div
                    class="font-secundaria font-weight-regular"
                    style="font-size: 18px"
                  >{{getModalType}}</div>
                </v-col>
                <v-col cols="12" align="center" class="pt-2">
                  <v-row justify="center" class="ml-2">
                    <v-col cols="auto">
                      <div class="font-secundaria font-weight-regular" style="font-size: 18px">
                        <div id="token">{{tokenGenerate}}</div>
                      </div>
                    </v-col>
                    <v-col cols="auto" @click="copy">
                      <icon name="copy" :size="20" style="cursor: pointer" tooltip="Copiar" />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" align="center" class="pt-4">
                  <div>
                    <button-cadu
                      text="OK"
                      @click="$emit('close')"
                      :backColor="$vuetify.theme.themes.light.primary1"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
            <div slot="footer"></div>
          </div>
        </modal-cadu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    sucessType: {
      type: String,
      default: ''
    },
    showSucess: {
      type: Boolean,
      required: true
    },
    successName: {
      type: String,
      default: 'Seu Token'
    },
    genericMessage: {
      type: String,
      default: ''
    },
    genericTitle: {
      type: String,
      default: 'Sucesso!'
    },
    width: {
      type: Number,
      default: 452
    },
    tokenGenerate: {
      type: String,
      required: true,
      default: 'SKSKSOPSKKOPSKS'
    }
  },
  data () {
    return {
      close: true,
      show: this.showSucess,

      code: this.tokenGenerate,
      iconStyle: {
        color: this.$vuetify.theme.themes.light.primary1
      },
      editMessage: `${
        this.successName
      } atualizad${this.getSexoType()} com sucesso!`,
      createMessage: `${
        this.successName
      } criad${this.getSexoType()} com sucesso!`,
      deleteMessage: `${
        this.successName
      } excluíd${this.getSexoType()} com sucesso!`,
      tokenGenerateMessageNew: `Novo Token gerado com sucesso:`,
      tokenGenerateMessageRefresh: `Gerado novo Token:`
    }
  },
  methods: {
    getSexoType () {
      return this.successName[this.successName.length - 1] === 'a' ? 'a' : 'o'
    },
    copy () {
      navigator.clipboard
        .writeText(this.code)
        .catch(e => {
          console.error(e)
          this.message = 'Sorry, unable to copy to clipboard.'
        })
    }
  },
  computed: {
    getModalType () {
      if (this.sucessType.toUpperCase() === 'EDIT') {
        return this.editMessage
      } else if (
        this.sucessType.toUpperCase() === 'NEW' ||
        this.sucessType.toUpperCase() === 'ADD'
      ) {
        return this.createMessage
      } else if (this.sucessType.toUpperCase() === 'DEL') {
        return this.deleteMessage
      } else if (this.sucessType.toUpperCase() === 'TOKEN') {
        return this.tokenGenerateMessageNew
      } else if (this.sucessType.toUpperCase() === 'REFRESHTOKEN') {
        return this.tokenGenerateMessageRefresh
      } else {
        return this.genericMessage
      }
    }
  },
  watch: {
    show () {
      if (!this.show) {
        this.$emit('close')
      } else {
        this.code = this.tokenGenerate
      }
    },
    showSucess () {
      this.show = this.showSucess
    }
  }
}
</script>
